import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface DepartmentItem {
  dept_code: string;
  dept_name: string;
}

export interface QueryRequest {
  dept_code?: string;
  sort_by?: string; // "employee" | "department"
}

export interface AttendanceRow {
  emp_code: string;
  emp_name: string;
  emp_name_en: string;
  dept_code: string;
  ext: string;
  clock_in: string;
  last_punch: string;
  status_code: string;
  status_display: string;
  leave_note: string;
}

export interface QueryResponse {
  rows: AttendanceRow[];
  total: number;
  query_time: string;
}

export interface ApiResponse {
  data?: QueryResponse;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const p9410Api = {
  async getDepartments(): Promise<DepartmentItem[]> {
    const res = await apiClient.get('/api/p9410/departments');
    return res.data.data || [];
  },

  async query(req: QueryRequest): Promise<ApiResponse> {
    const body: Record<string, string> = {};
    if (req.dept_code) body.dept_code = req.dept_code;
    if (req.sort_by) body.sort_by = req.sort_by;
    const res = await apiClient.post('/api/p9410/query', body);
    return res.data;
  },
};
